import * as Yup from 'yup';

export const TrackFormSchema = Yup.object().shape({
  name: Yup.string().required('Required'),
});
